var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangle43541(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 319,
    viewBox: "0 0 288 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.385986 7.845C0.385986 3.74343 3.71097 0.418457 7.81254 0.418457H280.09C284.436 0.418457 287.853 4.13445 287.49 8.46563L264.083 287.583C263.783 291.163 260.963 294.015 257.387 294.356L8.51665 318.058C4.15664 318.473 0.385986 315.044 0.385986 310.665V7.845Z",
    fill: "url(#paint0_linear_2514_42864)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81254 1.03337H280.09C284.076 1.03337 287.211 4.44168 286.877 8.41424L263.47 287.532C263.195 290.815 260.609 293.431 257.328 293.744L8.45835 317.445C4.45934 317.826 1.0009 314.682 1.0009 310.664V7.845C1.0009 4.08304 4.05057 1.03337 7.81254 1.03337Z",
    stroke: "#FFFBFB",
    strokeOpacity: 0.2,
    strokeWidth: 1.22982
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2514_42864",
    x1: 0.385986,
    y1: 159.625,
    x2: 288.165,
    y2: 159.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0EAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDEF3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle43541);
export default __webpack_public_path__ + "static/media/rectangle-43541.72352940cb9af50957364bbcc61e4b1f.svg";
export { ForwardRef as ReactComponent };